import {Button, Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'

export const ConfirmationModal = ({modalOpen, setModalOpen, deleteMails, isDeleting}: any) => {
  const {formatMessage} = useIntl()

  return (
    <>
      <Modal show={modalOpen} onHide={() => setModalOpen(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{formatMessage({id: 'Confirm Delete'})}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{formatMessage({id: 'Are you sure you want to delete this email?'})}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setModalOpen(false)}>
            {formatMessage({id: 'Cancel'})}
          </Button>
          <Button variant='danger' onClick={() => deleteMails()} disabled={isDeleting}>
            {isDeleting ? formatMessage({id: 'Deleting...'}) : formatMessage({id: 'Delete'})}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
